module.exports = __webpack_public_path__ + "static/media/Print_Marketing.78f5226e.jpg";